import {
  getHouseKeeperExperienceController,
} from "../../../Controllers/AppManagement/houseKeeper";

import {
  addExperienceController,
  deleteDataExperience
} from "../../../Controllers/AppManagement/babySitter";


import { __permissionsObj } from "../../../constants";
import ExperienceManager from "../common/ExperienceManager";

export default function HouseKeeperExperience() {
  return (
    <ExperienceManager
      navTitle="Housekeeper years of experience"
      getExperienceController={getHouseKeeperExperienceController}
      addExperienceController={addExperienceController}
      deleteExperienceController={deleteDataExperience}
      permissionType={__permissionsObj.HouseKeeper}
    />
  );
}